import { render, staticRenderFns } from "./ChromeIcon.vue?vue&type=template&id=3a9020d5&scoped=true"
import script from "./ChromeIcon.vue?vue&type=script&lang=js"
export * from "./ChromeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9020d5",
  null
  
)

export default component.exports